import * as React from 'react'
import Wind from '../../assets/svgIcons/Wind'
import './styles.scss'

interface Props {
  text: string
}

export const EmptyList = ({ text }: Props) => {
  return (
    <div className="empty-main-content">
      <div className="empty-main">
        <Wind height='100%' width='100%'/>
        <span>{text} :)</span>
      </div>
    </div>
  )
}
